import { z } from "zod";

export const ReportSalesMonthlyFilterSchemaV4 = z.object({
    property_id: z.string(), // Memastikan property_id adalah rentetan
    base_on: z.enum(["created_reservation"]), // Mengehadkan kepada nilai yang dibenarkan
    start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // Menguatkuasakan format YYYY-MM-DD
    end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // Menguatkuasakan format YYYY-MM-DD
});

export type ReportSalesMonthlyFilterV4Type = z.infer<typeof ReportSalesMonthlyFilterSchemaV4>;